var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}},[_c('circle',{attrs:{"id":"bulleticon","cx":"10","cy":"10","r":"10","fill":"#0d6efd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }